import axios from "axios";
const BlogsService = {
  getBlogs: async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/blogs`,
      );
      // console.log("Fetched blogs from API:", response.data); // Log the fetched blogs data
      if (!response.status || response.status !== 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.data;
      return data;
    } catch (e) {
      console.error("Failed to fetch blogs:", e);
      // Returns an empty array so your map() functions in React don't crash
      return [];
    }
  },
};

export default BlogsService;
